import {Component, Injector} from '@angular/core';
import {TUI_EDITOR_DEFAULT_EXTENSIONS, TUI_EDITOR_EXTENSIONS, tuiEditorOptionsProvider} from '@taiga-ui/editor';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  providers: [
    {
      provide: TUI_EDITOR_EXTENSIONS,
      deps: [Injector],
      useFactory: (injector: Injector) => [
        ...TUI_EDITOR_DEFAULT_EXTENSIONS,
        import('@taiga-ui/editor').then(({setup}) => setup({injector})),
      ],
    },
    tuiEditorOptionsProvider({
      enablePasteRules: false,
      enableInputRules: false,
      spellcheck: true
    })
  ],
})
export class EditorComponent extends BaseFieldType {
  readonly maxHtmlContentLength = this.environment.maxHtmlContentLength;
}
